module.exports = __webpack_public_path__ + "img/IMG_9033_L_BlackMatted.c5e329d5.jpg";